export const ALLOW_SERVICE_BINDING_FLAG = 'ALLOW_SERVICE_BINDING';
